import type { FunctionComponent } from "react";

import { useAggregatedDataV2 } from "~/hooks/useAggregatedDataV2.ts";
import userViewGuard from "~/hooks/useViewPermssionsCheck";
import { useAllDraftInvoices } from "~/modules/billing/api/draftInvoice/draftInvoiceQueries.ts";
import { useAllProcessedInvoices } from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import DraftInvoicesIndexView from "~/modules/billing/components/DraftInvoicesIndexView";
import { useAllUsers } from "~/modules/user/api/user/userQueries.ts";
import { PermissionNames } from "~/types/entityNames.ts";


const DraftInvoicesIndexPage: FunctionComponent = () => {
	const guard = userViewGuard([PermissionNames.CanManageInvoices, PermissionNames.CanViewInvoices]);
	if (guard) return guard;

	const { data, options } = useAggregatedDataV2({
		allDraftInvoices: useAllDraftInvoices(),
	});
	const { allDraftInvoices } = data;

	// prefetch all non-pending invoices and users to ensure they are available when needed
	useAllProcessedInvoices();
	useAllUsers();

	return <DraftInvoicesIndexView isLoading={options.isLoading}
								   draftInvoicesData={allDraftInvoices} />;
};

export default DraftInvoicesIndexPage;